import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-promoted-bulk-fulfillment',
		path: '/admin/promoted_bulk_fulfillment',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-promotedBulkFulfillment" */ './index'), {
			exportName: 'AdminPromotedBulkFulfillment',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
